import { BASE_URL, SITE_NAME } from '../config/seoConfig';

function slugToTitle(slug: string): string {
  return slug
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

const ROUTE_LABELS: Record<string, string> = {
  '/how-it-works': 'How It Works',
  '/pricing': 'Pricing',
  '/faq': 'FAQ',
  '/about': 'About',
  '/contact': 'Contact',
  '/privacy-policy': 'Privacy Policy',
  '/terms-of-use': 'Terms of Use',
  '/refund-policy': 'Refund Policy',
  '/skills': 'Your AI Skills',
  '/blog': 'Blog',
  '/glossary': 'AI Glossary',
  '/ai-for-software-engineers': 'AI for Software Engineers',
  '/ai-roadmap-for-engineering-managers': 'AI Roadmap for Engineering Managers',
  '/ai-learning-essentials-for-leaders': 'AI Learning Essentials for Leaders',
};

function normalizePath(pathname: string): string {
  if (pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export function generateBreadcrumbs(pathname: string): object | null {
  const path = normalizePath(pathname);
  if (path === '/') return null;

  if (path === '/glossary') {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: SITE_NAME, item: BASE_URL },
        { '@type': 'ListItem', position: 2, name: 'AI Glossary', item: `${BASE_URL}/glossary` },
      ],
    };
  }

  if (path.startsWith('/glossary/')) {
    const slug = path.slice('/glossary/'.length);
    const termLabel = slugToTitle(slug);
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: SITE_NAME, item: BASE_URL },
        { '@type': 'ListItem', position: 2, name: 'AI Glossary', item: `${BASE_URL}/glossary` },
        {
          '@type': 'ListItem',
          position: 3,
          name: termLabel,
          item: `${BASE_URL}/glossary/${slug}`,
        },
      ],
    };
  }

  const label =
    ROUTE_LABELS[path] ||
    path
      .slice(1)
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: SITE_NAME,
        item: BASE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: label,
        item: `${BASE_URL}${path}`,
      },
    ],
  };
}
